import { ScreenReaderOnly } from './ScreenReaderOnly';
/**
 * If you have a visible label for a control that is broken up visually with CSS / HTML
 * it should also be broken up audibly for screen reader users. This component returns a
 * ScreenReaderOnly component with a comma.
 *
 * If a label contains multiple distinct pieces of information, split them up with this component
 * to make screen readers pause between each piece of information.
 *
 * @see CS-7418 for example use in product cards
 */
export function ScreenReaderPause() {
    return <ScreenReaderOnly>,</ScreenReaderOnly>;
}
